import { render, staticRenderFns } from "./MobileCart.vue?vue&type=template&id=3198a9d9&scoped=true"
import script from "./MobileCart.vue?vue&type=script&lang=js"
export * from "./MobileCart.vue?vue&type=script&lang=js"
import style0 from "./MobileCart.vue?vue&type=style&index=0&id=3198a9d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3198a9d9",
  null
  
)

export default component.exports